<script lang="ts">
	import { createEventDispatcher, onMount } from 'svelte';
	import { fileUploadStore } from './fileUploadStore';

	export let openOnMount = false;
	export let accept: string;
	export let multiple = false;

	const dispatch = createEventDispatcher();

	let fileInput: HTMLInputElement;

	const changeSelectedFiles = () => {
		if (fileInput.files) {
			$fileUploadStore = [...fileInput.files];
			dispatch('fileUploaded');
		}
	};

	onMount(() => {
		if (openOnMount) fileInput.click();
		dispatch('mounted');
	});
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div on:click|capture={() => fileInput.click()}>
	<slot />

	<input type="file" {multiple} bind:this={fileInput} {accept} on:change={changeSelectedFiles} />
</div>

<style>
	input[type='file'] {
		display: none;
		block-size: 0;
		inline-size: 0;
	}
</style>
